export default function SidebarSeparator() {
  return <hr className="sidebar__separator" />;
}
